const CONTACT_SEARCH_FIELDS = [`name`, `cellPhone`, `homePhone`, `workPhone`, `otherPhone`, `email`, `preferredName`]

type MatchActivityContactSearchInput = {
  locationId?: string
  workspaceId?: string
  searchWorkspace?: boolean
  search: string
  page: number
}

export function buildMatchActivityContactSearch({
  locationId,
  workspaceId,
  searchWorkspace = false,
  search,
  page,
}: MatchActivityContactSearchInput) {
  const specificityFilter = searchWorkspace ? `workspaceId:${workspaceId}` : `locationId:${locationId}`
  return {
    search: `${specificityFilter} AND *${search}*`,
    pagination: { page, limit: 100 },
    sort: { field: `_score`, direction: `DESC` as const },
    magicTerms: true,
    fields: CONTACT_SEARCH_FIELDS,
  }
}
